import { createModel } from "@@/package/utils/ModelUtil";
import Model from "@@/package/mapper/Model";
import {AssessmentResultDetailModel} from "~~/package/mapper/assessment/model/AssessmentResultDetailModel";
import {
  AssessmentCoursePassTotalResultModel
} from "~~/package/mapper/assessment/model/AssessmentCoursePassTotalResultModel";

export class AssessmentResultListModel extends Model {
  constructor(
      public trackPassFlag: boolean = false,
      public assessmentList: AssessmentResultDetailModel[] = [],
      public coursePassTotalResultVOList: AssessmentCoursePassTotalResultModel[] = []
  ) {
    super();
  }

  public static create(model: Partial<AssessmentResultListModel>): AssessmentResultListModel {
    return createModel<AssessmentResultListModel>(AssessmentResultListModel, {
      ...model
    });
  }
}
